/**
 * BrandMark — 바이브타운 로고
 *
 * 32x32 viewBox, 어떤 크기든 size prop으로 확대 가능.
 * vibetown (2).zip / ui-atoms.jsx 의 SVG를 그대로 옮김.
 */
export interface BrandMarkProps {
  size?: number
  className?: string
}

export function BrandMark({ size = 28, className }: BrandMarkProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      aria-hidden="true"
      className={className}
    >
      <defs>
        <linearGradient id="vt-bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="var(--color-brand-grad-from)" />
          <stop offset="100%" stopColor="var(--color-brand-grad-to)" />
        </linearGradient>
      </defs>
      <rect width="32" height="32" rx="9" fill="url(#vt-bg)" />
      <circle cx="16" cy="9.5" r="3" fill="var(--color-brand-sun)" />
      <path
        d="M3.5 24 L11 12.5 L16 19.5 L21 12.5 L28.5 24 Z"
        fill="white"
      />
      <circle cx="16" cy="23" r="1.1" fill="var(--color-brand-sun)" />
    </svg>
  )
}
